<template>
	<div class="text-center training-page" :class="{ 'games-page': isGamesPage }">
		<nav v-show="!isMultiplyMode" class="text-uppercase main-games-list">
			<div class="training-link-area">
				<img src="../../assets/training/icon1.png" alt="" />

				<router-link to="/games/addition" class="btn btn-pink">
					{{ 'Speedy numbers' | translate }}
				</router-link>
			</div>

			<div class="training-link-area">
				<img src="../../assets/training/icon2.png" alt="" />

				<router-link to="/games/columns" class="btn btn-pink">
					{{ 'games.columns.name' | translate }}
				</router-link>
			</div>

			<div class="training-link-area">
				<img src="../../assets/training/icon7.png" alt="" />

				<router-link v-if="!isFree" to="/games/anzan" class="btn btn-pink">
					{{ 'Anzan' | translate }}
				</router-link>
			</div>

			<div class="training-link-area">
				<img src="../../assets/training/icon8.png" alt="" />

				<router-link v-if="!isFree" to="/games/negative" class="btn btn-pink">
					{{ 'games.negativeNumbers' | translate }}
				</router-link>
			</div>

			<div class="training-link-area">
				<img src="../../assets/training/icon4.png" alt="" />

				<router-link to="/games/abacus-game" class="btn btn-pink">
					{{ 'Abacus' | translate }}
				</router-link>
			</div>

			<div class="training-link-area">
				<img src="../../assets/training/icon3.png" alt="" />

				<router-link to="/games/abacus-random" class="btn btn-pink">
					{{ 'Abacus Random' | translate }}
				</router-link>
			</div>

			<div class="training-link-area">
				<img src="../../assets/training/icon5.png" alt="" />

				<button v-if="!isFree" @click="setMultiplyMode(true)" class="text-uppercase btn btn-pink">
					{{ 'Multiplication' | translate }}
				</button>
			</div>

			<div class="training-link-area">
				<img src="../../assets/training/icon6.png" alt="" />

				<router-link v-if="!isFree" to="/games/division" class="btn btn-pink">
					{{ 'Division' | translate }}
				</router-link>
			</div>

			<!-- <div class="training-link-area">
				<img src="../../assets/training/icon6.png" width="164" height="164" alt="" />

				<router-link to="/games/abacus-game" class="btn btn-pink">
					{{ 'Abacus' | translate }}
				</router-link>
			</div> -->

			<!-- <router-link to="/dashboard-student" class="btn btn-pink"
				>{{ 'Dashboard' | translate }}
			</router-link> -->
		</nav>

		<nav v-show="isMultiplyMode" class="multiply-list text-uppercase">
			<router-link to="/games/multiply" class="multiply-btn btn btn-pink">
				{{ 'Multiplication' | translate }}
			</router-link>
			<router-link to="/games/squared" class="multiply-btn btn btn-pink">
				{{ 'Squared' | translate }}
			</router-link>
			<router-link to="/games/mul-base" class="multiply-btn btn btn-pink">
				{{ 'Base 50/100' | translate }}
			</router-link>
			<router-link to="/games/mul-25x25" class="multiply-btn btn btn-pink">
				{{ '25x25' | translate }}
			</router-link>

			<div @click="setMultiplyMode(false)" class="btn btn-pink multiply-btn multiply-back">
				<svg fill="#FFFFFF" height="35px" width="35px" viewBox="0 0 26.676 26.676">
					<g>
						<path d="M26.105,21.891c-0.229,0-0.439-0.131-0.529-0.346l0,0c-0.066-0.156-1.716-3.857-7.885-4.59
		c-1.285-0.156-2.824-0.236-4.693-0.25v4.613c0,0.213-0.115,0.406-0.304,0.508c-0.188,0.098-0.413,0.084-0.588-0.033L0.254,13.815
		C0.094,13.708,0,13.528,0,13.339c0-0.191,0.094-0.365,0.254-0.477l11.857-7.979c0.175-0.121,0.398-0.129,0.588-0.029
		c0.19,0.102,0.303,0.295,0.303,0.502v4.293c2.578,0.336,13.674,2.33,13.674,11.674c0,0.271-0.191,0.508-0.459,0.562
		C26.18,21.891,26.141,21.891,26.105,21.891z" />
					</g>
				</svg>
			</div>
			<!-- <button class="multiply-btn btn btn-pink text-uppercase" @click="menu = 'main'">
				{{ 'Back' | translate }}
			</button> -->
		</nav>
	</div>
</template>

<script>
export default {
	name: 'game-list',
	data() {
		return {
			menu: 'main',
			isFree: JSON.parse(localStorage.getItem('userProfile'))?.is_free,
			prevRoute: null,
		}
	},
	methods: {
		setMultiplyMode(value) {
			if (value) {
				this.$router.push({
					path: "/dashboard-student/training",
					query: {
						'menu': "multiply",
					}
				})
			} else {
				this.$router.push({
					path: "/dashboard-student/training",
				})
			}

		}
	},
	computed: {
		isGamesPage() {
			return this.$route.path == '/games'
		},

		isMultiplyMode() {
			return this.$route.query.menu == 'multiply'
		}
	},

	// mounted() {
	// 	console.log("Route", this.$route.query.menu)
	// },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.multiply-back {
	width: 67px !important;
	height: 55px !important;
	padding: 3 !important;
	margin-top: 20px;

	transform: scale(0.7);
}

.training-page {
	width: 100%;

	@media (min-width: 1200px) {
		width: 80%;
		margin-right: auto;
	}

	&.games-page {
		margin-right: auto;
		margin-left: auto;
	}
}

.main-games-list {
	max-width: 750px;

	display: flex;
	flex-wrap: wrap;
	// padding: 20px 0;

	justify-content: space-evenly;

	@media (min-width: 1200px) {
		margin-right: auto;
		margin-left: 15%;

		justify-content: space-between;
	}

	.training-page.games-page & {
		margin-right: auto;
		margin-left: auto;

		background-color: #FFF;
		padding: 15px;


		@media (min-width: 1200px) {
			border-radius: 8px;
		}
	}
}

.training-link-area {
	display: block;
	width: 170px;

	margin: 6px 0;

	@media (max-width: 767px) {
		width: 145px;
	}

	& img {
		width: 134px;
		height: 134px;

		@media (max-width: 767px) {
			width: 130px;
			height: 130px;
		}
	}
}

.btn-pink {
	// display: block;
	// background-color: #e4467b;
	// color: #fff;
	// height: 44px;
	// line-height: 2;
	// margin: 0px auto 15px;
	// width: 260px;
	// cursor: pointer;

	// @media (max-width: 767px) {
	// 	margin: 0px auto 12px;
	// }

	// display: flex;
	width: 159px;
	// height: 34px;
	padding: 8px 16px;
	// flex-direction: column;
	// justify-content: center;
	// align-items: center;
	// gap: 10px;
	// flex-shrink: 0;

	color: #FFF;

	font-size: 12px;
	font-style: normal;
	font-weight: 900;
	// line-height: 150%;
	/* 18px */
	// letter-spacing: 0.6px;
	text-transform: uppercase;

	border-radius: 8px;
	border: 2px solid var(--, #FFF);
	background-color: #6a5ea4;
	// background: linear-gradient(97deg, #77A5FF 46.82%, #1C7E9D 97.14%);
	// box-shadow: 0px 4px 0px 0px rgba($color: #e9407a, $alpha: 0.8);

	@media (max-width: 767px) {
		width: 130px;
	}
}

.multiply-list {
	position: relative;

	flex-wrap: wrap;
	max-width: 600px;

	justify-content: space-between;

	margin: auto;

	margin-top: 15px;
	margin-left: 23.5%;

	z-index: 1;

	@media (max-width: 767px) {
		margin-left: 0;
		margin-right: 15px;
	}
}

.multiply-btn {

	margin: 5px;

	width: calc(50% - 15px);

	font-size: 14px;

	@media (max-width: 767px) {
		width: 100%;
	}
}

// .btn-pink:hover {
// 	background-color: #e85183;
// }
</style>
